import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "faqs-page" };
const _hoisted_2 = {
    key: 0,
    class: "faqs-page-content"
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import FaqsSection from './FaqsSection.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FaqsPage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getFaqs } = useContent();
        const faqs = ref([]);
        onMounted(() => {
            getCustomer();
            const faqName = route.query.name;
            if (faqName) {
                getFaqs(faqName, (result) => {
                    faqs.value = result?.faqItems || [];
                });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HeaderBlock, {
                    title: "FAQs",
                    allowBack: true
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(FaqsSection, { faqs: faqs.value }, null, 8, ["faqs"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
